import React from 'react'
import { FilterForm } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'

const Sidebar = ({data, query}) => {
  return (
    <div className="lg:pr-12">
      <SystemProvider>
        <FilterForm data={data} query={query} id="sidebar-filter-form"/>
      </SystemProvider>
    </div>
  )
}

export { Sidebar }
